"use client"

import { parseAsBoolean, useQueryState } from "nuqs"
import dynamic from "next/dynamic"
import { Box, Loader, rem } from "@mantine/core"
import classes from "./WebPhoneContainer.module.css"
import { useMediaQuery } from "@mantine/hooks"
import clsx from "clsx"
import { CollapsedWebPhone } from "./CollapsedWebPhone"
import { useWebPhoneViewStatusLogic } from "./wephoneViewLogic"
import { showNotification } from "@/lib/notifications"
import { useAppStoreContext } from "@/stores/appStore"
import { useWebphoneIsDisabled } from "@/components/webphone/useWebphoneIsDisabled"
import { usePathname } from "next/navigation"

const WebPhone = dynamic(() => import("@/components/webphone/WebPhone").then((mod) => mod.WebPhone), {
  ssr: false,
  loading: () => (
    <Box className="flex size-full flex-row items-center justify-center !overflow-hidden">
      <Loader color="blue" />
    </Box>
  ),
})

interface WebPhoneContainerProps {
  children?: React.ReactNode | React.ReactNode[]
}

export function WebPhoneContainer({ children }: WebPhoneContainerProps) {
  const isBigEnough = useMediaQuery("(min-width: 48em)")
  const pathname = usePathname()
  const { webphoneExpanded: expanded, webphonePopup: popup, webphonePoppedOut: poppedOut, setWebphonePoppedOut } = useAppStoreContext((s) => s)

  const [isPopup] = useQueryState("popup", parseAsBoolean.withDefault(false))
  const webphoneViewStatusLogic = useWebPhoneViewStatusLogic({ isPopup })
  const isWebphoneDisabled = useWebphoneIsDisabled()

  function openPopup() {
    const totalPopupHeight = (window?.innerHeight ?? popup.height) + 52

    const popupWebphone = window.open(
      "/webphone?popup=true",
      "Web Phone - Ring.io",
      `width=${popup.width},height=${totalPopupHeight},scrollbars=no,status=no,location=no,toolbar=no,copyhistory=no,menubar=no,popup=true,top=${window.screenTop + window.innerHeight / 2 - totalPopupHeight / 2},left=${window.screenLeft + window.innerWidth / 2 - popup.width / 2}`
    )

    if (!popupWebphone || typeof popupWebphone === "undefined") {
      showNotification({
        type: "warning",
        title: "Popups are blocked!",
        message: "Your system seems to block popups. Please allow popups for this site to use the webphone as a popup.",
        autoClose: 15 * 1_000,
      })
      // setWebphonePoppedOut(false)
    } else {
      // popupWebphone?.addEventListener("beforeunload", onPopupCloses)
      // popupWebphoneStatusInterval = setInterval(() => {
      //   if (!popupWebphone || popupWebphone.closed) {
      //     onPopupCloses()
      //   }
      // }, 1_000)
    }
  }

  return (
    <>
      <Box className={classes.container}>
        {!isPopup ? <Box className={classes.noPopupContainer}>{children}</Box> : <></>}
        <WebPhone
          isPopup={isPopup}
          openPopup={openPopup}
          classNames={{
            root: clsx(isPopup ? classes.webPhoneIsPopup : expanded || (!expanded && !isBigEnough) ? classes.webPhoneIsExpanded : "", pathname.includes("/messenger") ? classes.webPhoneInMessengerScreen : ""),
          }}
        />
      </Box>
      {isWebphoneDisabled === false && <CollapsedWebPhone isPopup={isPopup} />}
    </>
    // </Box>
  )
}
